import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll position to top whenever the route pathname changes.
// If the URL carries a hash (e.g. "/mouthguards-and-retainer/night-guard
// #guided-callback-anchor"), we wait a beat for the target section
// to mount, then scroll it into view smoothly. React Router does NOT
// do hash-scroll automatically after client-side navigation, so this
// tiny effect powers the "Talk to a smile expert" mega-menu deep-link
// and any similar in-page targeting.
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.startsWith("#") ? hash.slice(1) : hash;
            // Poll briefly (max ~1s) until the anchor element exists —
            // handles pages that mount their sections lazily below
            // heavy above-the-fold work.
            let tries = 0;
            const tick = () => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    return;
                }
                if (tries++ < 20) setTimeout(tick, 50);
            };
            tick();
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
}
